module.exports = __webpack_public_path__ + "img/FastShot.34019333.png";